import { atom } from "jotai/index";

export const isSubmitLoading = atom(false);
